import { Backdrop, Card, IconButton, Slide } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import CampaignAddressListItem from "../CampaignAddressesList/CampaignAddressListItem/CampaignAddressListItem";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { AwarenessCampaignMapActions } from "../../../../store/reducers/awareness_campaigns/map_reducer";

export default function AddressDetailCard() {
    const selectedAddressID = useAppSelector(state => state.awareness_campaign.map.selectedAddressID);

    const isOpen = Boolean(selectedAddressID);

    const dispatch = useAppDispatch();

    const handleClose = () => {
        dispatch(AwarenessCampaignMapActions.selectAddressID(null));
    };

    return (
        <>
            {/* invisible backdrop to close dialog when clicking outside */}
            <Backdrop open={isOpen} sx={{ bgcolor: 'rgba(0, 0, 0, 0)' }} onClick={handleClose} />

            <Slide
                direction="up"
                in={isOpen}
                mountOnEnter
                unmountOnExit
            >
                <Card
                    sx={{
                        position: 'absolute',
                        bottom: theme => theme.spacing(2),
                        right: theme => theme.spacing(2),
                        left: theme => theme.spacing(2),
                        px: 1,
                        pt: 2,
                    }}
                >
                    {selectedAddressID && (
                        <CampaignAddressListItem
                            ID={selectedAddressID}
                        />
                    )}
                    <IconButton onClick={handleClose} sx={{ position: 'absolute', top: theme => theme.spacing(1), right: theme => theme.spacing(1) }}>
                        <CloseIcon />
                    </IconButton>
                </Card>
            </Slide>
        </>
    );
}